import { RouteRecordRaw } from 'vue-router'

import NotFound from '@/modules/guestUi/pages/NotFound.vue'
import OrderConfirmation from '@/modules/guestUi/pages/OrderConfirmation.vue'
import SetAddOns from '@/modules/guestUi/pages/SetAddOns.vue'
import SetContact from '@/modules/guestUi/pages/SetContact.vue'
import SetGuests from '@/modules/guestUi/pages/SetGuests.vue'
import SetPayment from '@/modules/guestUi/pages/SetPayment.vue'
import SetSeatingTime from '@/modules/guestUi/pages/SetSeatingTime.vue'
import SetTables2 from '@/modules/guestUi/pages/SetTables2.vue'
import { ssrRoutes } from '@/router/ssr-routes'
import { useCheckoutStore } from '@/stores/checkout'

export const guestRoutes: RouteRecordRaw[] = [
  ...ssrRoutes,
  {
    path: '/guests',
    name: 'setGuests',
    component: SetGuests,
    meta: {
      guest: true,
      pageTitle: 'Guests',
    },
    beforeEnter: (to, from, next) => {
      return useCheckoutStore().isSetGuestsReady ? next() : next({ name: 'setShow' })
    },
  },
  {
    path: '/tables',
    name: 'setTable',
    component: SetTables2,
    meta: {
      guest: true,
      pageTitle: 'Tables',
    },
    beforeEnter: (to, from, next) => {
      return useCheckoutStore().isSetTablesReady ? next() : next({ name: 'setGuests' })
    },
  },
  {
    path: '/seating-time',
    name: 'setSeatingTime',
    component: SetSeatingTime,
    meta: {
      guest: true,
      pageTitle: 'Seating Time',
    },
    beforeEnter: (to, from, next) => {
      return useCheckoutStore().isSetSeatingTimeReady ? next() : next({ name: 'setTable' })
    },
  },
  {
    path: '/addons',
    name: 'setAddOns',
    // @ts-ignore
    component: SetAddOns,
    meta: {
      guest: true,
      pageTitle: 'Add-ons',
    },
    beforeEnter: (to, from, next) => {
      return useCheckoutStore().isAddOnsReady ? next() : next({ name: 'setSeatingTime' })
    },
  },
  {
    path: '/contact',
    name: 'setContact',
    component: SetContact,
    meta: {
      guest: true,
      pageTitle: 'Contact',
    },
  },
  {
    path: '/payment',
    name: 'payment',
    component: SetPayment,
    meta: {
      guest: true,
      pageTitle: 'Checkout',
    },
    beforeEnter: (to, from, next) => {
      const isStripeRedirectReturn =
        to.query.payment_intent_client_secret && to.query.reservation_id && to.query.reservation_key
      if (isStripeRedirectReturn) return next()
      const checkoutStore = useCheckoutStore()
      if (!checkoutStore.isDetailsReady) return next({ name: 'setSeatingTime' })
      return checkoutStore.hasSyncedGuestInfo ? next() : next({ name: 'setContact' })
    },
  },
  {
    path: '/order-confirmation/:reservationId/:reservationKey',
    name: 'order-confirmation',
    component: OrderConfirmation,
    props: true,
    meta: {
      guest: true,
      pageTitle: 'Order Confirmation',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
    meta: {
      guest: true,
      pageTitle: 'Page Not Found',
    },
  },
]
